import { jobService } from 'api/jobService';
import { GET_JOBS_FAILURE, GET_JOBS_REQUEST, GET_JOBS_SUCCESS } from 'constants/actionTypes';
import { jobsPayloadType } from 'type/JobsType';

export const jobs = {
  fetchJobs
};

function fetchJobs(payload: jobsPayloadType) {
  return async (dispatch: any) => {
    dispatch(request(GET_JOBS_REQUEST));
    jobService
      .fetchJobs(payload)
      .then((resp:any) => {
        return resp.json();
      })
      .then((data:any) => {
        if (data?.error || data?.message) {
          dispatch(failure(GET_JOBS_FAILURE, data?.message || "Error fetching jobs"));
        } else {
          dispatch(success(GET_JOBS_SUCCESS,data));
        }
      })
      .catch((error:any) => {
        dispatch(failure(GET_JOBS_FAILURE, error));
      });
  };
}

function request(type:string) {
  return { type: type };
}

function success(type:string,data:any) {
  return { type, payload: {data: data} };
}

function failure(type:string,message:string) {
  return { type, payload: { message } };
}